import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { logger } from '@/lib/logger';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isFormNeedsBackup(lastModified: string | null, lastBackup: string | null): boolean {
  if (!lastBackup) return true;
  if (!lastModified) return false;

  // Parse dates and convert to timestamps for accurate comparison
  // This handles different date formats from FormAssembly (YYYY-MM-DD HH:MM:SS)
  // and database (ISO 8601 with timezone)
  let modifiedDate: Date;
  let backupDate: Date;

  try {
    // FormAssembly dates come as "YYYY-MM-DD HH:MM:SS" without timezone
    // Convert to ISO format if needed for proper parsing
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(lastModified)) {
      modifiedDate = new Date(lastModified.replace(' ', 'T') + 'Z');
    } else {
      modifiedDate = new Date(lastModified);
    }

    backupDate = new Date(lastBackup);

    // Compare timestamps (milliseconds since epoch) for accuracy
    return modifiedDate.getTime() > backupDate.getTime();
  } catch (error) {
    logger.warn('Error comparing dates:', { lastModified, lastBackup, error });
    // Fallback to string comparison if date parsing fails
    return new Date(lastModified).getTime() > new Date(lastBackup).getTime();
  }
}
